export default __webpack_public_path__ + "static/media/_DSC0791.a418e55a.JPG";